import { useQuery } from '@apollo/client/react';
import { useDebounce } from 'use-debounce';
import { OrderByArg } from 'shared/domains/apollo/generated/types';
import { getAllMarketCodes, supportedMarketCodes } from 'shared/domains/markets/config';
import { transformSearchQuery } from './transformSearchQuery';
import { useTransformGraphqlDocument } from './useTransformGraphqlDocument';
import { useSearchContext } from '../../components/SearchProvider';
import { cleanObject } from '../cleanObject';
export function useSearchQuery(variables, options) {
    const { values, modifiers } = useSearchContext();
    const { query, filters, referrer, offset, limit, orderBy, columns } = values;
    const { where } = variables || {};
    const queryDocument = useTransformGraphqlDocument(columns);
    const userMarketCodes = getAllMarketCodes();
    const excludedMarketCodes = supportedMarketCodes.filter((item) => !userMarketCodes.includes(item));
    const orderByArray = Object.entries(orderBy || {}).reduce((acc, [key, value]) => {
        if (value) {
            acc.push({ [key]: value });
        }
        return acc;
    }, []);
    if (!orderByArray.find((item) => 'updatedAt' in item)) {
        orderByArray.push({ updatedAt: OrderByArg.Desc });
    }
    const [queryVariables] = useDebounce(Object.assign({ query,
        limit,
        referrer,
        offset }, cleanObject({
        where: Object.assign(Object.assign(Object.assign({}, filters), where), { marketCode: {
                notIn: excludedMarketCodes,
            } }),
        orderBy: orderByArray,
        modifiers,
    })), 250, {
        equalityFn(left, right) {
            return JSON.stringify(left) === JSON.stringify(right);
        },
    });
    const { data, loading, error } = useQuery(queryDocument, {
        variables: queryVariables,
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'cache-and-network',
        skip: options === null || options === void 0 ? void 0 : options.skip,
    });
    const transformQueryData = transformSearchQuery(data);
    return {
        data: transformQueryData,
        loading,
        error,
        query,
    };
}
